import PropTypes from 'prop-types'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { PRIMARY_LIGHT } from '../../styles/colors.style'

const StyledPaginatorTable = styled.table`
	border-spacing: 1px;
	margin: 1.5rem auto;

	td {
		background: white;
		color: ${PRIMARY_LIGHT};
		cursor: pointer;
		font-size: 1.4rem;
		height: 3rem;
		text-align: center;
		user-select: none;
		width: 3rem;
		&:hover {
			font-weight: bold;
		}
		&.active {
			background: ${PRIMARY_LIGHT};
			color: white;
			cursor: default;
		}
	}
`

function getPagesArray(totalPages, page) {
	if (totalPages <= 0 || !totalPages) return []
	let pagesArray = Array(totalPages)
		.fill(0)
		.map((_, index) => index + 1)
	const threshold = 11

	if (totalPages - page < ~~(threshold / 2)) {
		pagesArray = pagesArray.slice(-~~(threshold / 2) * 2)
	} else {
		if (pagesArray.length > threshold) {
			const indexLeft = Math.max(page - Math.ceil(threshold / 2), 0)
			pagesArray = pagesArray.slice(indexLeft, indexLeft + threshold)
		}
		if (pagesArray.length > threshold) {
			const indexRight = Math.min(
				page + Math.ceil(threshold / 2),
				totalPages
			)
			pagesArray = pagesArray.slice(indexRight, indexRight + threshold)
		}
	}
	return pagesArray
}

class PaginatorComponent extends React.Component {
	render() {
		const {
			loading,
			page,
			rowsPerPage,
			totalRows,
			goToPage,
			goToNext,
			goToPrevious,
		} = this.props
		const totalPages = Math.ceil(totalRows / rowsPerPage)
		if (totalPages === 1) return null

		const hasPrevious = page > 1
		const hasNext = page < totalPages

		const pagesArray = getPagesArray(totalPages, page)

		return (
			<StyledPaginatorTable>
				<tbody>
					<tr>
						{hasPrevious ? (
							<td onClick={() => (loading ? null : goToPrevious())}>
								<FontAwesome name="angle-left" />
							</td>
						) : null}
						{pagesArray.map((tmpPage, index) => {
							return (
								<td
									onClick={() => (loading ? null : goToPage(tmpPage))}
									key={index}
									className={tmpPage == page ? 'active' : ''}>
									{tmpPage}
								</td>
							)
						})}
						{hasNext ? (
							<td onClick={() => (loading ? null : goToNext())}>
								<FontAwesome name="angle-right" />
							</td>
						) : null}
					</tr>
				</tbody>
			</StyledPaginatorTable>
		)
	}
}

PaginatorComponent.propTypes = {
	loading: PropTypes.bool,
	page: PropTypes.number,
	rowsPerPage: PropTypes.number,
	totalRows: PropTypes.number,
	goToPage: PropTypes.func.isRequired,
	goToNext: PropTypes.func.isRequired,
	goToPrevious: PropTypes.func.isRequired,
}

export default PaginatorComponent
